var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropdownDiamond = function SvgDropdownDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18 0 6l3-6h14l3 6-10 12ZM7.625 5h4.75l-1.5-3h-1.75l-1.5 3ZM9 13.675V7H3.45L9 13.675Zm2 0L16.55 7H11v6.675ZM14.6 5h2.65l-1.5-3H13.1l1.5 3ZM2.75 5H5.4l1.5-3H4.25l-1.5 3Z",
    fill: "#000"
  })));
};
export { SvgDropdownDiamond as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDE4TDAgNkwzIDBIMTdMMjAgNkwxMCAxOFpNNy42MjUgNUgxMi4zNzVMMTAuODc1IDJIOS4xMjVMNy42MjUgNVpNOSAxMy42NzVWN0gzLjQ1TDkgMTMuNjc1Wk0xMSAxMy42NzVMMTYuNTUgN0gxMVYxMy42NzVaTTE0LjYgNUgxNy4yNUwxNS43NSAySDEzLjFMMTQuNiA1Wk0yLjc1IDVINS40TDYuOSAySDQuMjVMMi43NSA1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";